import _ from 'lodash'
import Backbone from 'backbone'
import template from './link-form.hbs'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import urlValidator from 'scoreboard/components/validators/url-validator'

var LinkForm = Backbone.View.extend({
	tagName: 'form',

	events: {
		'click .unlink': 'unlink',
		'click': '_onClick',
		'click .cancel': 'cancel'
	},

	initialize(opt = {}) {
		this.options = opt
	},

	render() {
		this.$el.empty().append(template(this.options))

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})

		this.markedField = new MarkedField({
			el: this.$('[name=href]'),
			validator: [ requiredValidator, urlValidator ]
		}).render()

		this.formView.start()

		return this
	},

	submit() {
		this.trigger('done', formHelper.readFromDom(this.el))
	},

	unlink() {
		this.trigger('unlink')
	},

	cancel() {
		this.trigger('remove')
	},

	_onClick: function (e) {
		// If the user selects an input element or accidentally clicks
		// on an empty area of the tooltip, clobber the event so other tooltips
		// don't unintentionally close (like in rich text widgets)
		e.stopPropagation()
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.markedField], 'remove')
	}

})

export default LinkForm

LinkForm.__filename__ = 'components/rich-text/link-form.js'
